import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getExcelHeaders, getHeaders } from 'auth/auth';
import { api } from 'constants/constant';

export const dashboardAPI = createApi({
  reducerPath: 'dashboard',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getApplicationDashboardInfo: builder.query({
      query: (applicationId) => {
        return {
          url: `b2c/loan/dashboard/loan_info/${applicationId}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    createSupportTicket: builder.mutation({
      query: ({ data }) => {
        return {
          url: `b2c/support/ticket/`,
          method: 'POST',
          body: data,
          headers: getExcelHeaders(),
        };
      },
    }),
  }),
});

export const { useGetApplicationDashboardInfoQuery, useCreateSupportTicketMutation } = dashboardAPI;
